"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: ", ";\n"], ["\n  display: inline-block;\n  position: ", ";\n"])), function (props) { return props.position; });
var Child = function (_a) {
    var children = _a.children, x = _a.x, y = _a.y, scatterRandomly = _a.scatterRandomly;
    return (react_1.default.createElement(Container, { position: scatterRandomly ? "absolute" : "relative", style: {
            left: x,
            top: y,
        } }, children));
};
Child.defaultProps = {
    x: 0,
    y: 0,
    scatterRandomly: false,
};
exports.default = Child;
var templateObject_1;
//# sourceMappingURL=Child.js.map